import React, {useEffect} from "react";
import '../css/landing.css';



import MainLogo from './../img/logo/just_name_log.png';
import MainVid from './../img/loop_vid.mp4'



function Landing() {

    useEffect(() => {

        // Check if the Url contains a fragment Indentifier
        if (window.location.hash) {
            const targetId = window.location.hash.substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                targetElement.scrollIntoView();
            }


        }


    })

    return (
       
        // {/*======================= Landing Pagee ================================== */}
        <header id="Home"> 

            
            <video playsInline autoPlay muted loop  src={MainVid} /> 
        
            <div className="container landing__contatiner" >
            
            <img src={MainLogo} alt="landing logo"></img>


            <div className="landing__nav">
              
              <a href="/#About">Artist</a>
              <a href="/#Portfolio">Portfolio</a>
              <a href="/#Contact">Contact</a>
             
              
           
            </div>
            
            <div className="landing__appointment">
                <a href="/booking">Book an Appointment</a>
            </div>
            </div>


            
        </header>

      

    );

}

export default Landing;
